/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  getIfsc,
  getMerchantProfile,
  updateMerchantProfile,
  getSignzyToken,
  getPanToGSTList,
  getPanVerifyApi,
  verifyKYCApi,
  getStateApi,
  getCityApi,
  kycFormSubmitApi,
  kycFormReSubmitApi,
  getBankVerifyApi,
  updateAccountApi,
  toggleEnvApi,
} from '../../api/completeProfile';
import ActionConstants from '../constants';

export const getMerchantProfileAction = (data) => {
  const payload = {
    serviceMethod: getMerchantProfile.bind(null, data),
    actionTypeSuccess: ActionConstants.GET_MERCHANT_PROFILE_SUCCESS,
    actionTypeFailure: ActionConstants.GET_MERCHANT_PROFILE_FAILURE,
    actionTypeRequest: ActionConstants.GET_MERCHANT_PROFILE_REQUEST,
  };
  return { type: ActionConstants.GET_MERCHANT_PROFILE_ACTION, payload };
};

export const updateMerchantProfileStore = (data) => {
  return { type: ActionConstants.GET_MERCHANT_PROFILE_SUCCESS, payload:{body: data} };
};

export const updateMerchantProfileAction = (data) => {
  const payload = {
    serviceMethod: updateMerchantProfile.bind(null, data),
    actionTypeSuccess: ActionConstants.UPDATE_MERCHANT_PROFILE_SUCCESS,
    actionTypeFailure: ActionConstants.UPDATE_MERCHANT_PROFILE_FAILURE,
    actionTypeRequest: ActionConstants.UPDATE_MERCHANT_PROFILE_REQUEST,
  };
  return { type: ActionConstants.UPDATE_MERCHANT_PROFILE_ACTION, payload };
};

export const getIfscAction = (data) => {
  const payload = {
    serviceMethod: getIfsc.bind(null, data),
    actionTypeSuccess: ActionConstants.GET_IFSC_SUCCESS,
    actionTypeFailure: ActionConstants.GET_IFSC_FAILURE,
    actionTypeRequest: ActionConstants.GET_IFSC_REQUEST,
  };
  return { type: ActionConstants.GET_IFSC_ACTION, payload };
};

export const getSignzyTokenAction = (data) => {
  const payload = {
    serviceMethod: getSignzyToken.bind(null, data),
    actionTypeSuccess: ActionConstants.GET_SIGNZY_SUCCESS,
    actionTypeFailure: ActionConstants.GET_SIGNZY_FAILURE,
    actionTypeRequest: ActionConstants.GET_SIGNZY_REQUEST,
  };
  return { type: ActionConstants.GET_SIGNZY_ACTION, payload };
};

export const getPanToGSTListAction = (data, authParams) => {
  const payload = {
    serviceMethod: getPanToGSTList.bind(null, data, authParams),
    actionTypeSuccess: ActionConstants.GET_PANTOGSTLIST_SUCCESS,
    actionTypeFailure: ActionConstants.GET_PANTOGSTLIST_FAILURE,
    actionTypeRequest: ActionConstants.GET_PANTOGSTLIST_REQUEST,
  };
  return { type: ActionConstants.GET_PANTOGSTLIST_ACTION, payload };
};

export const getPanVerifyAction = (data, authParams) => {
  const payload = {
    serviceMethod: getPanVerifyApi.bind(null, data, authParams),
    actionTypeSuccess: ActionConstants.GET_PAN_VERIFY_SUCCESS,
    actionTypeFailure: ActionConstants.GET_PAN_VERIFY_FAILURE,
    actionTypeRequest: ActionConstants.GET_PAN_VERIFY_REQUEST,
  };
  return { type: ActionConstants.GET_PAN_VERIFY_ACTION, payload };
};

export const getBankVerifyAction = (data, authParams) => {
  const payload = {
    serviceMethod: getBankVerifyApi.bind(null, data, authParams),
    actionTypeSuccess: ActionConstants.GET_BANK_VERIFY_SUCCESS,
    actionTypeFailure: ActionConstants.GET_BANK_VERIFY_FAILURE,
    actionTypeRequest: ActionConstants.GET_BANK_VERIFY_REQUEST,
  };
  return { type: ActionConstants.GET_BANK_VERIFY_ACTION, payload };
};

export const verifyKYCAction = (data, authParams) => {
  const payload = {
    serviceMethod: verifyKYCApi.bind(null, data, authParams),
    actionTypeSuccess: ActionConstants.VERIFY_KYC_SUCCESS,
    actionTypeFailure: ActionConstants.VERIFY_KYC_FAILURE,
    actionTypeRequest: ActionConstants.VERIFY_KYC_REQUEST,
  };
  return { type: ActionConstants.VERIFY_KYC_ACTION, payload };
};

export const getStateAction = (data, authParams) => {
  const payload = {
    serviceMethod: getStateApi.bind(null, data, authParams),
    actionTypeSuccess: ActionConstants.GET_STATE_SUCCESS,
    actionTypeFailure: ActionConstants.GET_STATE_FAILURE,
    actionTypeRequest: ActionConstants.GET_STATE_REQUEST,
  };
  return { type: ActionConstants.GET_STATE_ACTION, payload };
};

export const getCityAction = (data, target) => {
  const payload = {
    serviceMethod: getCityApi.bind(null, data),
    actionTypeSuccess: ActionConstants.GET_CITY_SUCCESS,
    actionTypeFailure: ActionConstants.GET_CITY_FAILURE,
    actionTypeRequest: ActionConstants.GET_CITY_REQUEST,
    extra: {
      target: target
    }
  };
  return { type: ActionConstants.GET_CITY_ACTION, payload };
};

export const kycFormSubmitAction = (data, authparams) => {
  const payload = {
    serviceMethod: kycFormSubmitApi.bind(null, data, authparams),
    actionTypeSuccess: ActionConstants.KYC_FORM_SUBMIT_SUCCESS,
    actionTypeFailure: ActionConstants.KYC_FORM_SUBMIT_FAILURE,
    actionTypeRequest: ActionConstants.KYC_FORM_SUBMIT_REQUEST,
  };
  return { type: ActionConstants.KYC_FORM_SUBMIT_ACTION, payload };
};

export const kycFormSubmitClear = () => {
  return { type: ActionConstants.KYC_FORM_SUBMIT_CLEAR };
};

export const kycFormReSubmitAction = (data, authparams) => {
  const payload = {
    serviceMethod: kycFormReSubmitApi.bind(null, data, authparams),
    actionTypeSuccess: ActionConstants.KYC_FORM_RESUBMIT_SUCCESS,
    actionTypeFailure: ActionConstants.KYC_FORM_RESUBMIT_FAILURE,
    actionTypeRequest: ActionConstants.KYC_FORM_RESUBMIT_REQUEST,
  };
  return { type: ActionConstants.KYC_FORM_RESUBMIT_ACTION, payload };
};

export const updateAccountAction = (data) => {
  const payload = {
    serviceMethod: updateAccountApi.bind(null, data),
    actionTypeSuccess: ActionConstants.UPDATE_ACCOUNT_SUCCESS,
    actionTypeFailure: ActionConstants.UPDATE_ACCOUNT_FAILURE,
    actionTypeRequest: ActionConstants.UPDATE_ACCOUNT_REQUEST,
  };
  return { type: ActionConstants.UPDATE_ACCOUNT_ACTION, payload };
};

export const toggleEnvAction = () => {
  const payload = {
    serviceMethod: toggleEnvApi.bind(null),
    actionTypeSuccess: ActionConstants.TOGGLE_ENV_SUCCESS,
    actionTypeFailure: ActionConstants.TOGGLE_ENV_FAILURE,
    actionTypeRequest: ActionConstants.TOGGLE_ENV_REQUEST,
  };
  return { type: ActionConstants.TOGGLE_ENV_ACTION, payload };
};

export const clearToggleEnvAction = () => {
  return { type: ActionConstants.TOGGLE_ENV_CLEAR };
};

